<dx-popup
  [dragEnabled]="false"
  [enableBodyScroll]="false"
  [height]="'auto'"
  [showCloseButton]="false"
  [showTitle]="true"
  [fullScreen]="appService.isSmallScreen()"
  [visible]="true"
  [width]="660"
  (onHiding)="closeDialog.emit(null);"
  [wrapperAttr]="{
    class: 'changePasswordPopupWrapper'
  }"
  maxHeight="90vh"
  title="{{'CHANGE_PASSWORD.COMPNAME' | translate}}">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="changePassword()" [disabled]="createRequestSent"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.RESET' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeDialog.emit(null);" [disabled]="createRequestSent" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <!-- ******************************** -->
  <!-- Popup Contents                   -->
  <!-- ******************************** -->

  <dx-form #changePasswordForm (onEditorEnterKey)="changePassword()" [colCount]="1" [formData]="changePasswordReq"
           [validationGroup]="formValidationGroup"
           id="form" labelMode="outside"
           style="width: 100%">
    <dxi-item [disabled]="true" dataField="email">
      <dxo-label [text]="'CHANGE_PASSWORD.EMAIL' | translate"></dxo-label>
    </dxi-item>

    <dxi-item [editorOptions]="oldPasswordEditorOptions" dataField="oldPassword"
              editorType="dxTextBox">
      <dxi-validation-rule
        message="{{'CHANGE_PASSWORD.OLD_PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
        type="required">
      </dxi-validation-rule>
      <dxo-label [text]="'CHANGE_PASSWORD.OLD_PASSWORD' | translate"></dxo-label>

    </dxi-item>

    <dxi-item [editorOptions]="newPasswordEditorOptions" dataField="newPassword"
              editorType="dxTextBox">
      <dxi-validation-rule
        message="{{'CHANGE_PASSWORD.NEW_PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
        type="required">
      </dxi-validation-rule>
      <dxo-label [text]="'CHANGE_PASSWORD.NEW_PASSWORD' | translate"></dxo-label>

    </dxi-item>

    <dxi-item [editorOptions]="confirmPasswordEditorOptions" dataField="confirmPassword"
              editorType="dxTextBox">
      <dxi-validation-rule
        message="{{'CHANGE_PASSWORD.CONFIRM_PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
        type="required">
      </dxi-validation-rule>
      <dxi-validation-rule [comparisonTarget]="newPasswordValue" comparisonType="==="
                           message="{{'ERROR.PASSWORDS_MISMATCH' | translate }}"
                           type="compare">
      </dxi-validation-rule>
      <dxo-label [text]="'CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate"></dxo-label>

    </dxi-item>

  </dx-form>
</dx-popup>
